export default "__VITE_ASSET__CgdyM2vL__"